import React from 'react';
import strings from '../../localization';
import TablePage from '../../common/TablePage';
import { withSnackbar } from 'notistack';
import * as Actions from "../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import { Grid } from '@material-ui/core';
import SelectControl from '../../components/controls/SelectControl';
import { getMonths, getYears } from '../../util/DateUtil';
import IconButton from "@material-ui/core/IconButton";
import { generateExportData, generateWebPresentationExport, getGksResData, getGksResExists } from '../../services/exportData/ExportDataService';
import { downloadExport, downloadReport, downloadXlsxReport } from '../../util/ReviewsUtil';
// import { generateReviserReview } from '../../services/report/ReportService';
// import { downloadReport } from '../../util/ReviewsUtil';

class ExportDataPage extends TablePage {

  constructor(props) {
    super(props);

    const months = getMonths();
    months.unshift({ id: -1, name: strings.months.all })

    const years = getYears();
    years.unshift({ value: -1, name: strings.years.all })

    const options = [{value: 'GKS', name: 'ГКС'}, {value: 'GKK', name: 'ГКК'}, {value: 'GKSGKK', name: 'ГКС+ГКК'}, {value: 'GKSRES', name: 'ГКС+РЕС'}];

    this.state = {
      ...this.state,
      generating: false,
      generatingWebPresentation: false,
      showAdd: false,
      showSerach: false,
      existingGksRes: [],
      data: {
        option: options[0],
      },
      filter: {
        options: options,
        months: months,
        years: years,
      },
    };
  }

  componentDidMount() {
    this.setState({
      companyId: this.props.auth.user.company.id
    });
    getGksResExists().then(response => {
      if (response.ok && response.data) {
        this.setState({ existingGksRes: response.data });
      } else {
        this.setState({ existingGksRes: [] });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    strings.setLanguage(nextProps.auth.user.language);
  }

  getPageHeader() {
    return <h1>{strings.exportData.pageTitle}</h1>
  }

  generateReport() {
    this.setState({ generating: true });
    let data = {
      companyId: this.state.companyId,
      option: this.state.data.option.value ? this.state.data.option.value : "",
      userId: this.props.auth.user.id
    };

    generateExportData(data).then(response => {
      if (!response.ok) {
        this.setState({ generating: false });
        return;
      }

      this.props.enqueueSnackbar(strings.mainBookOfBuriedList.PDF, { variant: 'success' });
      downloadExport(response, "Export-" + this.state.data.option.value);
      this.setState({ generating: false });
    })
  }

  /**
   * Point 22: every deceased for the public web presentation, as .xlsx. The back end needs
   * about two minutes for the ~198.000 rows, so the button stays disabled and states why.
   */
  generateWebPresentation() {
    this.setState({ generatingWebPresentation: true });

    let data = {
      companyId: this.state.companyId,
      userId: this.props.auth.user.id
    };

    generateWebPresentationExport(data).then(response => {

      this.setState({ generatingWebPresentation: false });

      if (!response || !response.ok) {
        this.props.enqueueSnackbar(strings.exportData.generateError, { variant: 'error' });
        return;
      }

      downloadXlsxReport(response, strings.exportData.webPresentationFileName);
    })
  }

  render() {
    return (
      <Grid id='table-page'>
        <div className='header'>
          {this.getPageHeader()}
        </div>
        <div className='review-select'>
          <React.Fragment >
            <SelectControl
              options={this.state.filter.options}
              selected={this.state.data.option}
              onChange={this.changeData}
              label={strings.exportData.options}
              name={"option"}
              nameKey={"name"}
              valueKey={"value"}
            />
          </React.Fragment>
        </div>
        <div className="report-button">
          <IconButton onClick={() => this.generateReport()} disabled={this.state.generating || this.state.generatingWebPresentation}
          >
            {strings.exportData.genereateSql}
          </IconButton>
        </div>

        <div className="report-button">
          <IconButton onClick={() => this.generateWebPresentation()} disabled={this.state.generating || this.state.generatingWebPresentation}
          >
            {this.state.generatingWebPresentation ? strings.exportData.generating : strings.exportData.webPresentation}
          </IconButton>
        </div>
        <div className='review-select'>
          <small>{strings.exportData.webPresentationHint}</small>
        </div>

        { this.state.data.option.value === 'GKSRES' && this.state.existingGksRes && this.state.existingGksRes.length > 0 &&
          this.state.existingGksRes.map((item, index) => (
            <div key={index} className="report-button">
              <IconButton onClick={() => {
                getGksResData({
                  fileName: item.fileName.replace('.sql', ''),
                  userId: this.props.auth.user.id,
                  companyId: this.state.companyId
                }).then(response => {
                  if (response.ok) {
                    downloadExport(response, item.fileName);
                  }
                });
              }}>
                {item.fileName} {item.lastUpdated ? new Date(parseInt(item.lastUpdated)).toLocaleString() : ''}
              </IconButton>
            </div>
          ))
        }
      </Grid>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(ExportDataPage)));